import { useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import useCreditCardEntryState from "../state";

import VideoTextRecognition from "./VideoTextRecognition";
import { validateCreditCard } from "./validateCreditCard";

export default function CreditCardVideoOCR() {
  const [
    {
      ocr: { show: showOCR, hasStream },
    },
    dispatch,
  ] = useCreditCardEntryState();

  const close = () => {
    dispatch({ type: "Close OCR" });
  };

  const checkVideoData = (data) => {
    const result = validateCreditCard(data.text);
    if (result.expireDate) {
      console.log("expire date", result.expireDate);
      const expDate = result.expireDate.split("/");

      dispatch({
        type: "Set Expire Date From OCR",
        month: expDate[0],
        year: expDate[1],
      });

      console.log("expire date", result.expireDate);
    }

    if (result.creditCardNumber) {
      console.log("CC NUMBER", result.creditCardNumber);

      dispatch({
        type: "Set Credit Card Number From OCR",
        number: result.creditCardNumber,
      });

      close();
    }
  };

  return (
    <AnimatePresence>
      {showOCR && (
        <Wrapper
          key="ocr"
          initial={{ rotateY: -180 }}
          animate={{
            rotateY: hasStream ? 0 : -180,
            transition: { duration: 0.4 },
          }}
          exit={{ rotateY: -180, transition: { duration: 0.4 } }}
        >
          <BackButton
            onClick={close}
            className="fas fa-times-circle"
          ></BackButton>
          <VideoTextRecognition setData={checkVideoData} />
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  width: min(400px, calc(100vw - 16px));
  aspect-ratio: 85.6 / 53.98;
  border-radius: 16px;
  overflow: hidden;
  z-index: 200;
  position: absolute;
  top: 0;
  backface-visibility: hidden;
`;

const BackButton = styled.div`
  position: absolute;
  top: 6px;
  right: 5px;
  color: #fff;
  text-shadow: rgba(0, 0, 0, 1) 0 0 6px;
  cursor: pointer;
  font-size: 26px;
  z-index: 1;
  display: block;
`;
